import { RootState, useAppSelector } from '..';

export const selectedUserAccount = (state: RootState) => state.selectedAccount;
export const useUserAccount = () => useAppSelector(selectedUserAccount);
